import React from 'react';
import InfoBroder from "../../../../assets/images/hardware-inclusive/info-border.svg"
const HardwareSignupCard = ({onHardwarePlanSelection, selectedCard, toCompareSelectedCardWith, cardRightData, cardLeftData, displayMoreInfo, cardInfo, selectionPayload}) => {

    const handleClick = () => {
        onHardwarePlanSelection(selectionPayload ?? toCompareSelectedCardWith);
    }
   
    return (
        <div className='cp-card-container'>
            <div className={`cp-card-wrapper row ${selectedCard === toCompareSelectedCardWith?'cp-card-selected':""}`} onClick={handleClick}>
                <div className='col-7'>{cardRightData}</div>
                <div className='col-5 cp-card-price'>{cardLeftData}</div>
            </div>
            <div className='cp-card-info'>
                {cardInfo && <img src={InfoBroder} alt="know more" onClick={()=>displayMoreInfo()}/>} 
            </div>  
        </div>
    );
};

export default HardwareSignupCard;